<template>
  <div class="checkout-form-container checkout-form">
    <p class="cart-card-title">Tell us about yourself</p>

    <section class="my-body-section mt-5">
      <div class="flex flex-col gap-3">

        <div class="flex flex-col 1170-bp:flex-row gap-3 1170-bp:gap-0">
          <label class="container mr-3">
            <span class="span"><b class="required-star">*</b> First Name</span>
            <validated-input v-model="updates.firstName" page="quote-builder" :showInfoIcon="false" name="First name" />
          </label>
          <label class="container">
            <span class="span"><b class="required-star">*</b> Last Name</span>
            <validated-input v-model="updates.lastName" name="Last name" page="quote-builder" :showInfoIcon="false" rules="required" />
          </label>
        </div>

        <div class="flex flex-col 1170-bp:flex-row  gap-3 1170-bp:gap-0">
          <label class="container mr-3">
            <span class="span"><b class="required-star">*</b> Email</span>
            <validated-input v-model="updates.email" name="Email" page="quote-builder" :showInfoIcon="false" rules="required|email" />
          </label>
          <label class="container">
            <span class="span"><b class="required-star">*</b> Phone</span>
            <validated-input v-model="updates.phone" name="Phone" page="quote-builder" :showInfoIcon="false" :rules="{ required: true, regex: /^\+?[0-9\s()-]*$/ }" />
          </label>
        </div>
        
        <div class="is-flex flex is-justify-content-space-between w-full gap-3 1170-bp:gap-0">
          <label class="container" >
            <span class="span">Company Name <span class="optional-flag">(optional)</span></span>
            <validated-input v-model="customer.companyName" name="Company" page="quote-builder" :showInfoIcon="false" :rules="{ required: false }" />
          </label>
        </div>
      </div>
    </section>   
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Step from '../../flow/steps/mixin'

export default {
  mixins: [Step],
  data () {
    return {
      customer: {}
    }
  },
  computed: {
    ...mapState('quote', ['quote'])
  },
  props: {
    showPrice: Boolean
  }, 
  mounted () {
    if (this.quote) {
      this.updates = this.quote.customer
    } else if (this.lead) {
      const { firstName, lastName, email, phone } = this.lead
      this.updates = {
        ...this.updates,
        firstName,
        lastName,
        email,
        phone
      }
    }
  },
  methods: {   
    async save() {
      await this.updateCustomerInfo()
      await this.updateLeadInfo()
    },   
    updateCustomerInfo() {
      return this.$store.dispatch('quote/quote.save', {
        eventName: 'customer.update',
        input: {
          customer: {
            ...this.quote.customer,
            firstName: this.updates.firstName,
            lastName: this.updates.lastName,
            phone: this.updates.phone,
            email: this.updates.email            
          }
        }
      })
    },
    async updateLeadInfo() {
      return await this.$store.dispatch('quote/lead.save', {...this.lead, ...this.updates, id: this.lead.id})
    }
  }
}
</script>

<style>
  @import '../../flow/styles/checkout-form.scss';
</style>
<style scoped lang="scss">
  .check-info {
    display: flex;
    align-items: center;

    .check-item {
      margin-right: 12px;
    }

    span {
      color: #767676;
      font-size: 0.875rem;
      font-weight: 600;
    }
  }
  .container-title-company-name {
    display: flex; 
    flex-direction: row; 
    justify-content: space-between;
    @media (max-width: 800px) {
      flex-direction: column;
    }
  }

  .cart-card-title {
    font-size: 24px;
    font-weight: 400;
    line-height: 28.8px;
    letter-spacing: -0.04em;
    color: #334155;
  }

</style>
